module.exports = __webpack_public_path__ + "media/images/riders/TITOURAN_CAROD-3d867430bd125fe7b79fad7d8d6e7949.png";